import { get } from "@services/apiService.js";
export default {
  getEmbedCodes() {
    return get(`/v4/embed-code-website/v1/embedcodes`)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
}